import { Component, OnInit } from '@angular/core';
import { EncryptionService } from 'src/app/service/encryption/encryption.service';
import { MatMenuTrigger } from '@angular/material/menu';
import { Router } from '@angular/router';
import { HttpService } from 'src/app/service/http/http.service';
import { Config } from 'src/app/app-constant';
import { MobileResponsiveService } from 'src/app/services/mobile-view/mobile-responsive.service';
import { ViewWillEnter } from '@ionic/angular';
import { DwmGenericServiceService } from '../../_DWM-Generic-Services/generic-service.service';
@Component({
  selector: 'app-dwm-report-tabs',
  templateUrl: './dwm-report-tabs.component.html',
  styleUrls: ['./dwm-report-tabs.component.scss'],
})
export class DwmReportTabsComponent  implements OnInit {
  buttonColorName: any;
  loggedInUserRole: any;
  loggedInUserName: any;
  loggedInUserCompanyID: any;
  isRndAdminUser = false;
  loggedInUserId: string | null = null;
  userIsAdminTypes: any = null;
 
  constructor(
    private router: Router, private dwmGenericServiceService: DwmGenericServiceService,
    private config: Config,
    private httpService: HttpService,  private encryptionService: EncryptionService,
    private mobileResponsiveService: MobileResponsiveService,
  
  ) {}


  ngOnInit() {
    this.loggedInUserName = sessionStorage.getItem('loggedInUserName');
    const loggedUserRole = sessionStorage.getItem('loggedInUserRole');
    this.loggedInUserId = sessionStorage.getItem('loggedInUserId');
    console.log('Loggedin User Id is..', this.loggedInUserId);
    if (loggedUserRole) this.loggedInUserRole = this.encryptionService.decryptData(loggedUserRole);

    this.loggedInUserCompanyID = Number(this.encryptionService.decryptData(sessionStorage.getItem('loggedInUserCompanyID')));

    this.buttonColorName = sessionStorage.getItem('buttonColorName');
    this.getDwmSetupData();
  }
  ionViewWillEnter() {
    this.userIsAdminTypes = this.dwmGenericServiceService.checkIsLoggedInUserIsAdmin();
  }

  mouseenterTriggerMenu(menuName: MatMenuTrigger) {
    if (window?.innerWidth > this.mobileResponsiveService?.minScreenSize?.lg992.size) menuName.openMenu();
  }

  getDwmSetupData() {
    this.httpService.callGetService(`${this.config.getDwmSetup}?companyId=${this.loggedInUserCompanyID}`).subscribe((res: any) => {
      const setup = res?.data?.[0];

      if (setup?.rndAdmin && this.loggedInUserName) this.isRndAdminUser = setup.rndAdmin.trim().toLowerCase() === this.loggedInUserName.trim().toLowerCase();
      console.log('Is RnD Admin User:', this.isRndAdminUser);
    });
  }


}
